import React from "react";
import clsx from "clsx"; 

const PrimaryButton = ({
  text = "Click Me",
  onClick,
  bgColor = "bg-[#02323F]", 
  className = "",
}) => {
  return (
    <button
      onClick={onClick}
      className={clsx(
        // Base styling
        "rounded-full  px-4 md:px-6 py-2 md:py-3 transition-all duration-200 ease-in-out active:scale-[101%]",
        "hover:bg-[#FCC101] hover:text-black",
        "text-white",
        bgColor,
        // Typography (Poppins)
        "font-poppins font-medium text-[14px] md:text-[16px] leading-[22px] tracking-[0.5px] align-middle",
        className // custom classes merge/override
      )}
    >
      {text}
    </button>
  );
};

export default PrimaryButton;
